// Generated by CoffeeScript 1.12.7

'use strict';

/* global document:false, window:false, navigator:false, fetch:false */

const SubscriptionsUIClass = (function() {
  let appName, constructionTime, isSubForced, loadCompleteTime, loadStartTime;

  const TEN_YEARS_IN_MILLISECONDS = 1000 * 60 * 60 * 24 * 365 * 10;

  const DOI_DISMISS_LIFE_IN_MILLISECONDS = 60 * 60 * 1000;

  appName = null;

  isSubForced = false;

  constructionTime = 0;

  loadStartTime = 0;

  loadCompleteTime = 0;

  const USER_AGENTS = [
    'googlebot',
    'bingbot',
    'ask jeeves',
    'yahoo! slurp',
    'seoagent',
    'AdsBot-Google',
    'AdsBot-Google-Mobile',
    'psbot',
    'gosospider',
    'sogou',
    'google web preview',
    'google wireless transcoder',
    'mediapartners-google',
    'baidu',
    'gigabot',
    'googlebot-image',
    'libwww-perl',
    'lwp-trivial',
    'msnbot',
    'siteuptime',
    'slurp',
    'teoma',
    'uptakebot',
    'voyager',
    'wordpress',
    'yahooseeker',
    'zibb',
    'zyborg',
    'wget',
    'curl',
  ];

  SubscriptionsUI.increment_visited_cookie = function() {
    let visited;
    visited = parseInt(Cookie.get('subscription_visited'));
    if (isNaN(visited)) {
      visited = 1;
    } else {
      ++visited;
    }
    const subscription_last_visited = new Date().getTime();
    Cookie.set('subscription_visited', visited, {
      maxAge: TEN_YEARS_IN_MILLISECONDS,
      domain: document.domain,
    });
    return Cookie.set('subscription_last_visited', subscription_last_visited, {
      maxAge: TEN_YEARS_IN_MILLISECONDS,
      domain: document.domain,
    });
  };

  function SubscriptionsUI() {
    let now, ref;
    now = new Date();
    constructionTime = now.getTime();
    this.version = '2.7.2';
    appName = this._get_app_name();
    now = new Date();
    if (OptimizeSuite != null) {
      if ((ref = OptimizeSuite.TrackingHub) != null) {
        if (typeof ref.add === 'function') {
          ref.add('subscriptionUIdelegated', {
            goalType: 'subscription',
            _useSDS: window._useSDS,
            totalLatency: now.getTime() - constructionTime,
          });
        }
      }
    }
    isSubForced = window.location.href.indexOf('subs_force=') > -1;
    if (
      isSubForced &&
      (OptimizeSuite != null ? OptimizeSuite.TrackingHub : void 0) != null
    ) {
      OptimizeSuite.TrackingHub.add('subscriptionUIForced', {
        goalType: 'subscription',
      });
    }
    if (!(window._useSDS || this._should_not_show_subsUI())) {
      this._show_subscribe_drawer();
    }
  }

  SubscriptionsUI.prototype._should_show_doi = function() {
    const optin_value =
      document.getElementById('double_optin') != null
        ? document.getElementById('double_optin').value
        : null;
    const double_optin = optin_value != null && optin_value ? true : false;
    return (
      appName !== 'user_sessions' &&
      appName !== 'itier/subscription_center' &&
      appName !== 'sub_center' &&
      !Cookie.get('subscription_doi_dismissed') &&
      (double_optin || Cookie.get('optin') || Cookie.get('optin_reminder'))
    );
  };

  SubscriptionsUI.prototype._show_subscribe_drawer = function() {
    let divisionDropdown;
    if (!Cookie.get('close_subscribe_drawer')) {
      divisionDropdown = document.getElementById('subscribe-division');
      if (
        divisionDropdown !== null &&
        divisionDropdown.getAttribute('data-options_decoded') === 'false'
      ) {
        divisionDropdown.setAttribute('data-options_decoded', 'true');
        document
          .querySelectorAll('#subscribe-division > option')
          .forEach(element => {
            const decodedName = element.textContent
              .split('')
              .reverse()
              .join('');
            return (element.textContent = decodedName);
          });
      }
      const subscribeDrawer = document.getElementById('subscribe-drawer');
      if (subscribeDrawer !== null) {
        subscribeDrawer.style.display = '';
      }
    }
  };

  SubscriptionsUI.prototype._user_has_sub_cookie = function() {
    let c, i, len;

    const cookies = [
      'subscriber_email',
      'scid',
      'l',
      'user_id',
      'c',
      'snickerdoodle',
      'macaroon',
    ];
    for (i = 0, len = cookies.length; i < len; i++) {
      c = cookies[i];
      if (Cookie.get(c)) {
        return true;
      }
    }
    return false;
  };

  SubscriptionsUI.prototype._should_not_show_subsUI = function() {
    if (isSubForced) {
      return false;
    } else if (
      this._user_has_sub_cookie() ||
      this._is_bot() ||
      this._skip_subscription_ui() ||
      this._is_email_click_traffic()
    ) {
      return true;
    } else if (
      Cookie.get('hide_sub_modal') &&
      this._should_hide_subscribe_drawer()
    ) {
      return true;
    } else if (appName === 'user_sessions') {
      return true;
    } else {
      return false;
    }
  };

  SubscriptionsUI.prototype._should_hide_subscribe_drawer = function() {
    const no_drawer =
      Cookie.get('close_subscribe_drawer') || Cookie.get('hide_sub_banner');
    if (no_drawer) {
      return true;
    }
  };

  SubscriptionsUI.prototype._is_email_click_traffic = function() {
    const utm_medium = new RegExp('[\\?&]utm_medium=([^&#]*)').exec(
      window.location.href
    );
    if (
      (utm_medium != null &&
        utm_medium[1] != null &&
        utm_medium[1].toLowerCase() === 'email') ||
      Cookie.get('_tpmed') === 'email'
    ) {
      return true;
    } else {
      return false;
    }
  };

  SubscriptionsUI.prototype._skip_subscription_ui = function() {
    if (new RegExp('[\\?&]z=skip').test(window.location.href)) {
      return true;
    }
  };

  const _is_sub_str = function(string, subStr) {
    return string.toUpperCase().indexOf(subStr.toUpperCase()) > -1;
  };

  SubscriptionsUI.prototype._is_bot = function() {
    let i, len, userAgent;
    const userAgentHeader = navigator.userAgent;
    if (userAgentHeader) {
      for (i = 0, len = USER_AGENTS.length; i < len; i++) {
        userAgent = USER_AGENTS[i];
        if (_is_sub_str(userAgentHeader, userAgent)) {
          return true;
        }
      }
    }
    return false;
  };

  SubscriptionsUI.prototype._get_page_info = function() {
    let ref, ref1;
    const page_info = {};
    const data_app = document
      .getElementsByTagName('head')[0]
      .getAttribute('data-app');
    if (data_app != null && data_app.length > 0) {
      page_info.app = encodeURIComponent(data_app);
    } else if (
      (Optimize != null
        ? (ref = Optimize.suiteData) != null
          ? ref.app
          : void 0
        : void 0) != null &&
      (Optimize != null
        ? (ref1 = Optimize.suiteData) != null
          ? ref1.app.length
          : void 0
        : void 0) > 0
    ) {
      page_info.app = encodeURIComponent(Optimize.suiteData.app);
    }
    return page_info;
  };

  SubscriptionsUI.prototype._get_app_name = function() {
    const tmpAppName = this._get_page_info().app;
    return (appName = tmpAppName != null ? tmpAppName.toLowerCase() : null);
  };

  SubscriptionsUI.prototype._dismiss_subscribe_modal = function(container) {
    container.style.display = 'none';
    return container.hideSpotlight && container.hideSpotlight();
  };

  SubscriptionsUI.prototype.seq = function(arr, callback, index) {
    // first call, without an index
    if (typeof index === 'undefined') {
      index = 0;
    }

    arr[index](() => {
      index++;
      if (index === arr.length) {
        callback();
      } else {
        window.SubscriptionsUI.seq(arr, callback, index);
      }
    });
  };

  SubscriptionsUI.prototype.insertScript = function($script, callback) {
    const s = document.createElement('script');
    s.type = 'text/javascript';
    if ($script.src) {
      s.onload = callback;
      s.onerror = callback;
      s.src = $script.src;
    } else {
      s.textContent = $script.innerText;
    }

    // re-insert the script tag so it executes.
    document.head.appendChild(s);

    // clean-up
    $script.parentNode.removeChild($script);

    // run the callback immediately for inline scripts
    if (!$script.src) {
      callback();
    }
  };

  SubscriptionsUI.prototype.scriptsDone = function() {
    const DOMContentLoadedEvent = document.createEvent('Event');
    DOMContentLoadedEvent.initEvent('DOMContentLoaded', true, true);
    document.dispatchEvent(DOMContentLoadedEvent);
  };
  //Required because just appending element to document does not execute script tags
  SubscriptionsUI.prototype.executeScripts = function($container) {
    // get scripts tags from a node
    const $scripts = $container.querySelectorAll('script');
    const runList = [];

    [].forEach.call($scripts, $script => {
      runList.push(callback => {
        window.SubscriptionsUI.insertScript($script, callback);
      });
    });

    // insert the script tags sequentially
    // to preserve execution order
    if (runList.length > 0) {
      window.SubscriptionsUI.seq(runList, window.SubscriptionsUI.scriptsDone);
    }
  };

  SubscriptionsUI.prototype._get_doi_modal_and_show = function(overlayColor) {
    let now;
    const url = '/app/subscriptions/doi';
    now = new Date();
    loadStartTime = now.getTime();
    fetch(url, {
      method: 'GET',
    })
      .then(resp => {
        if (!resp.ok) {
          throw 'error';
        }
        return resp.text();
      })
      .then(data => {
        now = new Date();
        loadCompleteTime = now.getTime();
        const $container = document.createElement('div');
        $container.id = 'subscribe_doi_modal_container';
        $container.style.display = 'none';
        $container.style.position = 'fixed';
        $container.style.zIndex = '9999';
        $container.innerHTML = data;
        document.body.appendChild($container);
        window.SubscriptionsUI.executeScripts($container);
        if (document.getElementById('doi-email-address')) {
          const emailId = document.getElementById('email_id');
          document.getElementById('doi-email-address').textContent =
            emailId === null ? '' : emailId.value;
        }
        if (document.getElementById('no_doi') !== null) {
          return;
        }
        $container.style.display = '';
        return setTimeout(() => {
          const dlg_width = window
            .getComputedStyle($container)
            .width.slice(0, -2);
          const dlg_height = window
            .getComputedStyle($container)
            .height.slice(0, -2);
          const windowHeight = window.document.documentElement['clientHeight'];
          const windowWidth = window.document.documentElement['clientWidth'];
          const left = (windowWidth - dlg_width) / 2;
          const top = (windowHeight - dlg_height) / 2;
          overlayColor = overlayColor != null ? overlayColor : '#eee';
          $container.style.top = `${top}px`;
          $container.style.left = `${left}px`;

          $container.spotlight({
            opacity: 0.7,
            color: overlayColor,
            exitEvent: 'none',
          });
          now = new Date();
          if (
            (OptimizeSuite != null ? OptimizeSuite.TrackingHub : void 0) != null
          ) {
            OptimizeSuite.TrackingHub.add('subscriptionDOIDialogShown', {
              goalType: 'subscription',
              uiType: 'modal-dialog',
              loadingLatency: loadCompleteTime - loadStartTime,
              totalLatency: now.getTime() - constructionTime,
            });
          }
          document.getElementById('doi_dlg').addEventListener('dismiss', () => {
            SubscriptionsUI._dismiss_subscribe_modal($container);
            Cookie.set('subscription_doi_dismissed', true, {
              maxAge: DOI_DISMISS_LIFE_IN_MILLISECONDS,
              domain: document.domain,
            });
            if (
              (OptimizeSuite != null ? OptimizeSuite.TrackingHub : void 0) !=
              null
            ) {
              return OptimizeSuite.TrackingHub.add(
                'subscriptionDOIDialogHidden',
                {
                  goalType: 'subscription',
                  uiType: 'modal-dialog',
                }
              );
            }
          });
        }, 500);
      });
  };

  return SubscriptionsUI;
})();

function initWhenDependencies() {
  const cond =
    window.Cookie &&
    window.Optimize &&
    window.OptimizeSuite &&
    window.OptimizeSuite.TrackingHub;
  if (cond) {
    window.SubscriptionsUI = new SubscriptionsUIClass();

    SubscriptionsUIClass.increment_visited_cookie();

    if (window.SubscriptionsUI._should_show_doi()) {
      window.SubscriptionsUI._get_doi_modal_and_show('#333');
    }

    return null;
  }
  return setTimeout(initWhenDependencies, 250);
}

initWhenDependencies();
